import type { Market } from '../dataProvider/types';

/** Currency symbol per market: £ for uk, $ for us, € for ie. */
const SYMBOL_BY_MARKET: Record<Market, string> = {
  uk: '£',
  us: '$',
  ie: '€',
};

// Grouped, 2-dp number formatting (deterministic en-US grouping; the symbol is
// chosen by market separately so the glyph never depends on ICU locale data).
const groupedAmount = new Intl.NumberFormat('en-US', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

/**
 * Format a user's DERIVED balance in their market's currency (e.g. 12.34, 'uk'
 * -> "£12.34"; 1234.5, 'us' -> "$1,234.50"). A non-numeric balance renders as
 * an em dash.
 */
export const formatBalance = (amount: unknown, market: unknown): string => {
  const n = Number(amount);
  if (amount === null || amount === '' || !Number.isFinite(n)) return '—';
  const symbol = SYMBOL_BY_MARKET[market as Market] ?? '';
  return `${symbol}${groupedAmount.format(n)}`;
};
